/* eslint-disable import/prefer-default-export */
export const BW_WEB_LOTUS_TOGGLE = 'bw_web_lotus_toggle';
export const ENABLE_CHARTS_SURVEY = 'BW_enable_charts_survey';

// All possible treatment values for the bw_web_lotus_toggle split
export const LOTUS_ON = 'on';
export const LOTUS_OFF = 'off';
export const LOTUS_ONLY = 'lotus';

export const ENABLE_CHARTS_SURVEY_ON = 'on';
export const ENABLE_CHARTS_SURVEY_OFF = 'off';

export const LOTUS = 'LOTUS';
export const LOLA = 'LOLA';
export const NCEP = 'NCEP';

export const BW_SHOW_RUNTIMES = 'BW_show_runtimes';

// All possible treatment values for the BW_show_runtimes split
export const BW_SHOW_SWELL_RUNTIME = 'BW_runtimes_swell';
export const BW_SHOW_WEATHER_RUNTIME = 'BW_runtimes_weather';
export const BW_ALL_RUNTIMES = 'BW_runtimes_all';
export const BW_NO_RUNTIMES = 'BW_runtimes_none';



// WEBPACK FOOTER //
// ./src/common/constants.js